import React, { useEffect, useState } from "react";
import "../style.scss";
import { useNavigate, useOutletContext } from "react-router-dom";
import Sidebar from "../../../../components/sidebar";
import BuildingIcon from "../../../../icons/BuildingIcon";
import TagBlueIcon from "../../../../icons/TagBlueIcon";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../router/all_routes";
import { logHourRequestLists } from "../../../../core/data/redux/logHour/_logHourAction";
import { logHourFormatTime } from "../../../../constants/date";
import { CommonPagination } from "../../../../core/components/common/CommnPagination";
import RejectLogRequestModal from "../../../../components/rejectLogRequestModal";
import AcceptRequestModal from "../../../../components/acceptRequestModal";
import { AcceptRequestModalType } from "../../../../constants/utlis";
import { apiPageLimit, capitalizeFullName } from "../../../../constants/common";

const LogHoursRequests = () => {
  const { isSidebarOpen } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const routes = all_routes;

  const logHourData = useSelector((state: any) => state?.logHour);
  const logHourRequests = logHourData?.logHourRequestList;
  const totalCount = logHourData?.totalCount;

  const [page, setPage] = useState<number>(1);
  const pageSize = apiPageLimit;

  const [showRejectLogRequestModal, setShowResendInviteModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState<any>(null);

  const [showAcceptRequestModal, setShowAcceptRequestModal] = useState(false);
  const [modalType, setModalType] = useState<AcceptRequestModalType>("");
  const [selectedRequestUuid, setSelectedRequestUuid] = useState<string | null>(null);

  // Fetch requested log hours on component mount
  useEffect(() => {
    const params: any = { page, limit: pageSize };
    dispatch(logHourRequestLists(params));
  }, [dispatch,page]);

  const totalPages = Math.ceil(totalCount / pageSize);

  const handleRejectLogRequestModal = (user: any) => {
    setSelectedRequest(user);
    setShowResendInviteModal(true);
  };

  const handleCloseRejectLogRequestModal = () => {
    setShowResendInviteModal(false);
    setSelectedRequest(null);
  };

  const handleOpenDeleteModal = (type: AcceptRequestModalType, uuid: string) => {
    setModalType(type);
    setSelectedRequestUuid(uuid);
    setShowAcceptRequestModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowAcceptRequestModal(false);
    setSelectedRequestUuid(null);
  };


  return (
    <div className="layout">
      <Sidebar isOpen={isSidebarOpen} />
      <main className="content">
        <div className="profileSettings request-screen">

          <div className="rounded add-mileage-inner">
            <div className="add-properties-heading d-flex align-items-center gap-3 mb-4">
              <h2 className="mb-0">Approvals</h2>
            </div>

            <div className="row g-3 mb-3">
              {logHourRequests?.length > 0 ? (
                logHourRequests?.map((request: any) => {
                  return (

                    <div className="mb-4 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                      <div className="custom-card mx-auto">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start">
                            <span
                              className={request?.main_category?.name.toLowerCase() == "material participation" ? "category-badge green" : "category-badge yellow"}
                            >
                              {request?.main_category?.name}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <h5 className="mt-3">
                              {request?.sub_activity?.name}
                            </h5>

                            <div className="d-flex justify-content-end mt-2">
                              <span className="time-badge">
                                {logHourFormatTime({ hours: request?.hours, minutes: request?.minutes })}
                              </span>
                            </div>
                          </div>

                          <div className="mt-3 d-flex flex-wrap align-items-center">
                            <span className="tag tag-red mb-2 d-flex gap-1">
                              <BuildingIcon />
                              {request?.property?.name}
                            </span>
                            <span className="tag tag-blue mb-2 d-flex gap-1">
                              <TagBlueIcon />
                              {request?.activity?.name}
                            </span>
                          </div>
                        </div>

                        <div className="status-row d-flex justify-content-around flex-wrap">
                          <span className="status-badge">Logged By</span>
                          <div className="d-flex align-items-center rejected-area">
                            <img
                              src={request?.user?.image ? `${request?.user?.image}` : "/assets/img/userCircle.png"}
                              alt="Owner"
                              className="owner-img me-2"
                            />
                            <div>
                              <span className="owner-role">{request?.user?.role_label}</span>
                              <span className="fw-semibold d-block text-dark">
                                {capitalizeFullName(request?.user?.name)}
                              </span>
                            </div>
                          </div>

                          <div className="button-area d-flex gap-2">
                            <button
                              className="accept-button d-inline-flex justify-content-center align-items-center"
                              onClick={() => handleOpenDeleteModal("acceptRequestByOwner", request?.uuid)}
                            >
                              Accept
                            </button>
                            <button
                              className="reject-button d-inline-flex justify-content-center align-items-center"
                              onClick={() => handleRejectLogRequestModal(request)}
                            >
                              Reject
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-center w-100 py-4">No request found.</p>
              )}
            </div>

            {/* Pagination */}
            <CommonPagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
          </div>
        </div>
      </main>

      <RejectLogRequestModal
        show={showRejectLogRequestModal}
        onHide={handleCloseRejectLogRequestModal}
        data={selectedRequest}
      />

      <AcceptRequestModal
        show={showAcceptRequestModal}
        onHide={handleCloseDeleteModal}
        type={modalType}
        uuid={selectedRequestUuid}
      />

    </div>
  );
};

export default LogHoursRequests;
